import { render, staticRenderFns } from "./popup-bind-gong-xu.vue?vue&type=template&id=e10a1d54&scoped=true"
import script from "./popup-bind-gong-xu.vue?vue&type=script&lang=js"
export * from "./popup-bind-gong-xu.vue?vue&type=script&lang=js"
import style0 from "./popup-bind-gong-xu.vue?vue&type=style&index=0&id=e10a1d54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10a1d54",
  null
  
)

export default component.exports